
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/travel-english",
      function () {
        return require("private-next-pages/courses/travel-english.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/travel-english"])
      });
    }
  